export default function () {
  const url = this.getAttribute("url");

  setTimeout(function () {
    window.location.href = url;
  }, 1500);
}
